<template>
  <transition name="scroll-to-top-fade">
    <button v-if="visible"
            @click="scrollToTop"
            type="button"
            class="scroll-to-top"
            aria-label="Наверх страницы"
    >
      <i class="bi-arrow-up"></i>
    </button>
  </transition>
</template>

<script>
const SHOW_THRESHOLD = 400;

export default {
  name: "ScrollToTop",
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  unmounted() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.visible = window.scrollY > SHOW_THRESHOLD;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped lang="scss">
.scroll-to-top {
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 1000;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--green-color);
  color: var(--white-color);
  font-size: 1.25rem;
  line-height: 1;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--primary-green-color-hover);
  }
}

.scroll-to-top-fade-enter-active,
.scroll-to-top-fade-leave-active {
  transition: opacity 0.2s ease;
}

.scroll-to-top-fade-enter-from,
.scroll-to-top-fade-leave-to {
  opacity: 0;
}
</style>
